import { Box } from '@mui/material';
import React, { memo } from 'react';

const MobileView = ({children}) => {
  return (
    <Box display={{ xs: 'block', sm: "block", md: "none" }} width={'100%'}>
      {children}
    </Box>
  )
}

export default memo(MobileView);
